module.exports = __webpack_public_path__ + "img/KENG_Cover.dc7981d4.jpg";